import { discountGroupConstants } from '../constants';

export function discountGroups(state = {}, action) {
  switch (action.type) {
    case discountGroupConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case discountGroupConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case discountGroupConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddDiscountGroup(state = {}, action) {
  switch (action.type) {
    case discountGroupConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case discountGroupConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case discountGroupConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetDiscountGroup(state = {}, action) {
  switch (action.type) {
    case discountGroupConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case discountGroupConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case discountGroupConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateDiscountGroup(state = {}, action) {
  switch (action.type) {
    case discountGroupConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case discountGroupConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case discountGroupConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}